import { useState } from "react";
import React from "react";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../Navbar/Navbar";
import { useMediaQuery } from 'react-responsive';
import './Header.css';
import BurgerMenu from "../BurgerMenu/BurgerMenu";
import MobileNav from "../MobileNav/MobileNav";

const Header = () => {
  const [showNav, setShowNav] = useState(false);
  const location = useLocation();
  const isTabletOrDesktop = useMediaQuery({ query: '(min-width: 768px)' })

  const toggleOpenNav = () => {
    setShowNav(!showNav);
  };

  useEffect(() => {
    (async () => {
      setShowNav(false);
    })();
  }, [location]);

  return (
    <>
      <div className="header-container">
        <Link className="header-title" to="/">
          The Lucille Graham Trust
        </Link>
        {!isTabletOrDesktop && (
          <div onClick={toggleOpenNav}>
            <BurgerMenu isOpen={showNav}/>
          </div>
        )}

        {isTabletOrDesktop && <Navbar />}
      </div>
      {showNav && <MobileNav />}

    </>
  );
}

export default Header;